<template>
    <div class="product">
        <div class="banner">
                <el-carousel height="330px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <!-- <video height="300px" loop="loop" autoplay><source :src="item" type="video/mp4"/></video> -->
                        <img v-if="languageType == 0" @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                        <img v-else @click="toProductdetail(item.category,item.productName)" :src="item.enPicUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="series">
            <div class="menu">
                <ul>
                    <li v-for="(item,index) in seriesList" :key="index" :class="currentIndex == item.sort?'active':''" @click="checkIndex(item.id,item.sort)">
                        <p>{{item.name}}</p>
                        <span>{{ item.enName}}</span>
                    </li>
                </ul>
            </div>
            <div class="local">
                <p v-if="languageType == 0">当前位置：首页 > 产品展示 
                    > {{ seriesList[currentIndex-1].name }}</p>
                <p v-else>Location: Home > Products > {{ seriesList[currentIndex-1].enName}}</p>
            </div>
            
        </div>
        <div class="product_list">
            <router-view :categoryId="categoryId" ref="addOrUpdate" :languageType="languageType" @changeIndex ="changeIndex"></router-view>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            isRouterview:false,
            categoryId:1,
            currentIndex:1,
            bannerList:[],
            seriesList:[
                
            ],
            productList:[
                
            ],
        }
    },
    created () {
        // this.languageType = sessionStorage.getItem('languageType')
        this.$emit('changeIndex',5)
        this.getCategoryList()
        this.getBannerList ()
        
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getBannerList()
            }
        }

    },
    mounted () {
        document.documentElement.scrollTop = 0
    },
    methods:{
        changeIndex (val) {
            this.currentIndex = val
        },
        getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                    'type':6,
                     'productId':'',
                    'client':''
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.bannerList = arr
                } else {
                    this.bannerList = []
                }
            })
        },
        
        getCategoryList () {
            this.$http({
                url: this.$http.adornUrl('/web/category/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.seriesList = data.page.list.slice(0,4).sort((a, b) => a.sort - b.sort)
                    this.categoryId = data.page.list[0].id
                } else {
                    this.dataList = []

                }
            })
        },
        checkIndex (id,sort) {
            const path = this.$route.name
            this.pageIndex = 1
            this.categoryId = id
            this.currentIndex = sort
            if(path != 'productlist'){
                this.$router.push({ name:'productlist'})
            }
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id)
            })
        },
        toProductdetail (id,name) {
            var self = this
            if ( self.$route.path == '/product/productdetail'){
                self.$nextTick(() => {
                    self.$refs.addOrUpdate.getDataList(name)
                })
            }else {
                self.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}})
            }
            
        }
        
    }
}
</script>

<style lang="less" scoped>
    .product {
         max-width: 1920px;
        .banner {
            height: 330px;
            img {
                height: 330px;
                cursor: pointer;
            }
        }
        .series {
            width: 1220px;
            margin: 0 auto;
            overflow: hidden;
            height: 76px;
            .menu {
                float: left;
                margin-top: 19px;
                ul {
                    li {
                        float: left;
                        // width: 150px;
                        padding: 0 40px;
                        cursor: pointer;
                        border-left: 1px solid #b2b2b2;
                        position: relative;
                        &:hover {
                            p {
                                color: #e21711;
                            }
                            span {
                                color: #e21711;
                            }
                        }
                        p {
                            color: #606060;
                            font-size: 20px;
                        }
                        span {
                            color: #606060;
                            font-size: 14px;
                        }
                         &:last-child {
                            border-right: 1px solid #b2b2b2;
                        }

                    }
                    li.active {
                        p {
                            color: #e21711;
                        }
                        span {
                            color: #e21711;
                        }
                    }
                    li::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        height: 3px;
                        left: 0;
                        bottom: -15px;
                        background-color: #e21711;
                        opacity: 0;
                        transition: transform 0.2s ease-out,opacity 0.2s ease-out;
                        transform-origin: 50% 0%;
                        transform: scale(0.01,1);
                    }
                    li.active::after {
                        opacity: 1;
                        transform: scale(1,1);
                    }
                }
            }
            .local {
                float: right;
                p {
                    color: #606060;
                    font-size: 16px;
                    margin: 31px 0;
                }
            }
        }
        .product_list {
            // height: 1676px;
            position: relative;
            background-color: #f4f4f4;
            overflow: hidden;
            min-height: 630px;
            
        }
        .product_list::before {
            content: '';
            display: block;
            position: absolute;
            top: -170px;
            left: -410px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/long.png)no-repeat center center;
            z-index: 1;
        }
        .product_list::after {
            content: '';
            display: block;
            position: absolute;
            right: -275px;
            bottom: -200px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/tu.png)no-repeat center center;
            z-index: 1;
        }
    }
</style>
<style lang="less">
    .page {
        .el-pagination {
            display: inline-block;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active{
                background-color:#e21711
        }
        .el-pagination.is-background .el-pager li {
            border: 1px solid #e21711;
            color: #e21711
        }
        .el-pagination.is-background .el-pager li:not(.active):hover{
            color: #e21711;
        }
        .el-pagination.is-background .btn-prev {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-left:before {
            color: #e21711;
        }
         .el-pagination.is-background .btn-next {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-right:before {
            color: #e21711;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/product.vue